module.exports = __webpack_public_path__ + "img/homework.64b9e7ee.png";